/* tslint:disable */
import {
    defineMessages
} from 'react-intl';

export default defineMessages({
    cancelledMatch: {
        id: 'matchList.MatchRow.RowMiddle.cancelledTitle',
        defaultMessage: 'Cancelled',
    },
    upcomingFavorite: {
        id: 'matchList.upcomingFavorite',
        defaultMessage: "You don’t have favorite upcoming games. You can add event to «Favorites» by clicking on star in the left part of matches list and never miss interesting events!"
    },
    outrightsFavorite: {
        id: 'matchList.outrightsFavorite',
        defaultMessage: "You don’t have favorite outrights. You can add event to «Favorites» by clicking on star in the left part of matches list and never miss interesting events!"
    },
    resultsFavorite: {
        id: 'matchList.resultsFavorite',
        defaultMessage: "You don’t have favorite results. You can add event to «Favorites» by clicking on star in the left part of matches list and never miss interesting events! "
    }
});